import { Action } from 'redux-actions';
import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getSparePartRequestLineDetailsRequest } from '../../../api/SparePart/getSparePartRequestLineDetailsQuery';

import { GetSparePartRequestLineDetailsPayload } from './actionCreators';
import * as types from './actionTypes';

function* getSparePartRequestLinesWorker(action: {
  payload: GetSparePartRequestLineDetailsPayload;
}): Generator {
  const { sparePartRequestLineId } = action.payload;

  yield executeSagaRequest(
    types.GET_SPARE_PART_REQUEST_LINE_DETAILS,
    getSparePartRequestLineDetailsRequest({ sparePartRequestLineId }),
    { indexer: sparePartRequestLineId },
  );

  yield put(
    types.GET_SPARE_PART_REQUEST_LINE_DETAILS.end({ sparePartRequestLineId }),
  );
}
function* getSparePartRequestLinesWatcher() {
  yield takeEvery<Action<GetSparePartRequestLineDetailsPayload>>(
    types.GET_SPARE_PART_REQUEST_LINE_DETAILS.BASE,
    getSparePartRequestLinesWorker,
  );
}

export default function* sparePartRequestLineDetailsSaga(): Generator {
  try {
    yield all([getSparePartRequestLinesWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
